<template>
  <v-card>
    <v-flex xs12 v-if="messages">
      <message :messages="messages"></message>
    </v-flex>
    <v-card-title>
      <v-flex xs6>
        <div class="title">Sub Item</div>
      </v-flex>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="index" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.subItemNo }}</td>
        <td class="text-xs-left">{{ props.item.subItemLimit }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" :review="checkAccess(['travelRatingReview'])" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doNew">New SubItem<v-icon>mdi-plus</v-icon></v-btn>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected SubItem?
      <div class="title">{{deleteSubItem}}</div>
    </confirm>
  </v-card>
</template>
<script>
import * as TableConst from '@/mixins/table'
import { mapGetters, mapActions } from 'vuex'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [
        { text: 'Sub Item No', value: 'subItemNo' },
        { text: 'Sub Item Limit', value: 'subItemLimit' },
        TableConst.tableActionHeader
      ],
      pagination: {
        sortBy: 'subItemNo'
      },
      deleteSubItem: '',
      promptRemove: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    pkgRiskItemMenu() {
      return this.$store.state.parameters.scheme.pkgRiskItemMenu
    }
  },
  watch: {
    'fetchSubItem': function(value) {
      if (value !== false) {
        if (this.ids.itemNo !== 'new') {
          this.fetchData(this.ids.itemNo)
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'pkgRiskItemMenuInit'
    ]),
    async fetchData(itemNo) {
      const expand = {
        scheme: this.ids.scheme,
        planNo: this.ids.planNo,
        riskNo: parseInt(this.ids.riskNo),
        itemNo: parseInt(itemNo)
      }
      if (this.pkgRiskItemMenu.init !== 1) {
        await this.pkgRiskItemMenuInit(expand)
      }
      const apiURI = this.pkgRiskItemMenu.menu.pkgRiskSubItems
      if (apiURI) {
        try {
          const expand = {
            scheme: this.ids.scheme,
            planNo: this.ids.planNo,
            riskNo: this.ids.riskNo,
            itemNo: itemNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((pkgRiskSubItem) => {
              const convertPkgRiskSubItem = {
                scheme: pkgRiskSubItem.scheme,
                planNo: pkgRiskSubItem.planNo,
                riskNo: pkgRiskSubItem.riskNo,
                itemNo: pkgRiskSubItem.itemNo,
                subItemNo: pkgRiskSubItem.subItemNo,
                subItemLimit: pkgRiskSubItem.subItemLimit
              }
              this.items.push(convertPkgRiskSubItem)
            })
          } else {
            this.items = []
          }
          this.loading = false
        } catch (error) {
          this.loading = false
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL')
        this.loading = false
        this.items = []
      }
    },
    doReview(data) {
      this.$emit('doReview', data.item)
    },
    doNew() {
      this.$emit('doNew')
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedSubItem = data
        this.deleteSubItem = data.subItemNo + ' - ' + data.subItemLimit
      }
    },
    async doRemove() {
      const apiURI = this.pkgRiskItemMenu.menu.pkgRiskSubItemDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          scheme: this.selectedSubItem.scheme,
          planNo: this.ids.planNo,
          riskNo: this.selectedSubItem.riskNo,
          itemNo: this.selectedSubItem.itemNo,
          subItemNo: this.selectedSubItem.subItemNo,
          subItemLimit: this.selectedSubItem.subItemLimit
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.fetchData(this.ids.itemNo)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Risk Sub Item')
      }
    }
  },
  props: {
    fetchSubItem: {
      type: Boolean,
      default: false
    },
    ids: {
      type: Object,
      default() {
        return {
          scheme: null,
          planNo: null,
          riskNo: null,
          itemNo: null
        }
      }
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
